<script setup lang="ts">
import { ref } from "vue";
import MobileMenuList from "@/components/Menu/MobileMenuList.vue";
import type { NavigationItem, ToggleParams } from "@/components/Menu/type";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useNavigation } from "@/hook/useNavigation";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

const route = useRoute();

const handleToggle = ({ item, expanded }: ToggleParams) => {
  console.log(`菜单 "${item.label}" 已${expanded ? "展开" : "折叠"}`);
};

const { mobileFooterMenuItems } = useNavigation();

// 监听路由变化
watch(
  () => route.fullPath,
  () => {
    gsap.to(window, {
      duration: 0.3,
      scrollTo: 0,
    });
    // 刷新 ScrollTrigger（解决高度塌陷）
    // ScrollTrigger.refresh();
  }
);
</script>

<template>
  <footer class="footer">
    <MobileMenuList
      class="footer-menu"
      sub-class="footer-submenu"
      :items="mobileFooterMenuItems"
      accordion
      @toggle="handleToggle"
    />
  </footer>
</template>

<style scoped>
.footer {
  width: 100%;
  background: #eae0d6;
  padding: 40px;
  transition: padding 0.3s ease;
}

/* 给 MobileMenuList 内的子菜单添加 Grid 过渡 */
.footer-menu :deep(.submenu-wrapper) {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s ease-out;
}

.footer-menu :deep(.submenu-wrapper.is-expanded) {
  max-height: 2000px; /* 足够大的值，覆盖所有子菜单可能的高度 */
  transition: max-height 0.5s ease-in;
}

.footer-menu :deep(.submenu-content) {
  overflow: visible;
}

.footer-menu :deep(.menu-item) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-menu :deep(.menu-item-header) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  cursor: pointer;
  color: black;
}

.footer-menu :deep(.menu-item-label) {
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
}

.footer-menu :deep(.menu-item-arrow) {
  transition: transform 0.3s ease;
  color: black;
}

.footer-menu :deep(.menu-item-arrow.rotated) {
  transform: rotate(180deg);
}

.footer-submenu {
  list-style: none;
  padding: 0 0 8px 20px;
  margin: 0;
}

.footer-submenu :deep(.submenu-item) {
  padding: 8px 0;
}

.footer-submenu :deep(.submenu-link),
.footer-submenu :deep(.submenu-text) {
  color: black;
  font-size: 14px;
  text-decoration: none;
  line-height: 1.5;
}

@media (max-width: 640px) {
  .footer {
    padding: 20px;
  }
}
</style>
